import React from "react";
import { Column, Columns, Stack, Text } from "@origin-digital/ods-core";
import AutocompleteField from "./AutocompleteField";
import { Field } from "formik";
import HelperText from "./HelperText";
import ContactField from "./ContactField";
import { ConnectionTypeEnum } from "src/components/Premises/types";

const LicensedElectrician: React.FC = () => {
  return (
    <Columns
      collapseBelow="md"
      space={{ xs: "none", md: "xlarge" }}
      alignY="stretch"
    >
      <Column width="2/3">
        <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
          <ContactField
            contactType="ELECTRICIAN"
            name="licensedElectrician"
            label="Licensed electrician"
          />
          <Field
            component={AutocompleteField}
            name="connectionType"
            label="Connection type"
            options={[
              { label: "Permanent", value: ConnectionTypeEnum.PERMANENT },
              { label: "Temporary", value: ConnectionTypeEnum.TEMPORARY },
              { label: "Temp in perm", value: ConnectionTypeEnum.TEMPPERM },
            ]}
          />
        </Stack>
      </Column>
      <Column width="1/3">
        <HelperText>
          <Stack>
            <Text variant="body-small" tone="neutralLight">
              <strong>Permanent</strong> - installed in a permanent place.
            </Text>
            <Text variant="body-small" tone="neutralLight">
              <strong>Temporary</strong> - for construction only, to be removed
              when construction ends.
            </Text>
            <Text variant="body-small" tone="neutralLight">
              <strong>Temp in perm</strong> - for construction only, but
              installed in a permanent place and remains on site when
              construction ends.
            </Text>
          </Stack>
        </HelperText>
      </Column>
    </Columns>
  );
};

export default LicensedElectrician;
